import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateTimeUnit',
  standalone: false
})
export class TranslateTimeUnitPipe implements PipeTransform {
  private translate = inject(TranslateService);

  public transform(value: number, unit: 'day' | 'hour' | 'minute' = 'day'): string {
    return this.handleUnitDiff(value, unit);
  }

  private handleUnitDiff(diff: number, unit: 'day' | 'hour' | 'minute' ) {
    let translatePrefix = '';

    if (diff === 1) {
      translatePrefix = '1';
    } else if ((diff >= 2) && (diff <= 4)) {
      translatePrefix = '2to4';
    } else {
      translatePrefix = '5';
    }

    return diff + '\u00A0' + this.translate.instant(`dayDiffPipe.${translatePrefix}.${unit}`);
  }
}
